import { IconName, Icon } from '../../Icon';

type SideoverBannerProps = {
  label: string;
  icon?: IconName;
  variant?: 'default' | 'warning';
};

export const SideOverBanner = ({ label, icon, variant = 'default' }: SideoverBannerProps) => {
  const isWarning = variant === 'warning';
  return (
    <div
      className={`flex items-center gap-x-2 content-center place-content-start w-[calc(100vw+16px)] sm:w-[680px] -ml-8 sm:-ml-12 h-16 sm:h-12 mt-12 ${
        isWarning ? 'bg-darkMode-warning/20' : 'bg-palette-600/20'
      }`}
    >
      {icon && (
        <Icon
          icon={icon}
          className={`ml-8 ${isWarning ? 'text-darkMode-warning/80' : 'text-palette-600/80'}`}
        />
      )}
      <p className={`mt-1 ${isWarning ? 'text-darkMode-warning/80' : 'text-palette-600/80'}`}>{label}</p>
    </div>
  );
};
